import { Box, Flex, Image, Text } from "@chakra-ui/react";
import ripikOptimus from "../Icons/ripikOptimus.png";
import React from "react";
const Navbar = () => {
  return (
    <Flex
      w="100%"
      boxShadow="md"
      pos="sticky"
      top="0"
      bgColor="white"
      zIndex="1000"
      justifyContent="space-between"
      alignItems="center"
    >
      <Box w="33%"></Box>
      <Text textAlign="center" w="33%" fontWeight="600" fontSize="20px">
        BURDEN MIX OPTIMIZER
      </Text>
      <Flex align="center" w="33%" justify="right">
        <Text fontStyle="italic">Powered By</Text>
        <Image h="70px" src={ripikOptimus} />
      </Flex>
    </Flex>
  );
};

export default Navbar;
